import React from 'react';
import { connect } from 'react-redux';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import { getApplyByPhoneProps } from 'page_modules/business-vac/redux';

import styles from './__styles__/styles.scss?modules';

const ApplyByPhoneButton = ({
  data: {
    title,
    dtmTag,
    phoneInfo: { url }
  }
}) => {
  return (
    <section className={styles.container}>
      <a
        className={styles.link}
        href={url}
        onClick={() => sendDTMClickEvent(dtmTag)}
      >
        {title}
      </a>
    </section>
  );
};

const mapStateToProps = state => ({
  data: getApplyByPhoneProps(state).data
});

export default connect(mapStateToProps)(ApplyByPhoneButton);
